var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as dayjs from 'dayjs';
import * as lodash from './lodash';
export function getPlotAxis(plot) {
    var categoryAxis;
    var valueAxis;
    if (plot.type === 'grid') {
        var grid = plot;
        categoryAxis = grid.xAxis.concat(grid.yAxis).filter(function (axis) { return axis.isCategroy(); });
        valueAxis = grid.xAxis.concat(grid.yAxis).filter(function (axis) { return !axis.isCategroy(); });
    }
    else if (plot.type === 'polar') {
        categoryAxis = [plot.angleAxis, plot.radiusAxis].filter(function (axis) {
            return axis.isCategroy();
        });
        valueAxis = [plot.angleAxis, plot.radiusAxis].filter(function (axis) { return !axis.isCategroy(); });
    }
    return { categoryAxis: categoryAxis, valueAxis: valueAxis };
}
function getClosestPoints(axis, x) {
    return axis
        .getAxisSeries()
        .filter(function (series) { return series.type !== 'scatter'; })
        .map(function (seriesModel) {
        var points = seriesModel.getState().points;
        var item = lodash.minBy(points, function (point) { return Math.abs(x - point.plotX); });
        var dataIndex = points.indexOf(item);
        return seriesModel.getWrappedPoint(dataIndex);
    });
}
export function getPlotInfoAtPoint(plot, x, y) {
    var _a = getPlotAxis(plot) || {}, _b = _a.categoryAxis, categoryAxis = _b === void 0 ? [] : _b, valueAxis = _a.valueAxis;
    var category = '';
    var dataIndex;
    var tooltipPoints = [];
    categoryAxis.forEach(function (axis) {
        var categoryIndex = Math.round(axis.invertPoint(x, y));
        var label = axis.scale.categories[categoryIndex];
        dataIndex = categoryIndex;
        category = label;
        var axisSeries = axis.getAxisSeries();
        axisSeries.forEach(function (seriesModel) {
            var points = seriesModel.getState().points;
            var point = points[categoryIndex];
            if (!point) {
                return;
            }
            if (point.items) {
                point.items.forEach(function (item) {
                    return item.visible &&
                        tooltipPoints.push(__assign({ seriesIndex: seriesModel.seriesIndex, encode: { name: item.name }, dataIndex: dataIndex }, item));
                });
                return;
            }
            if (!isNaN(parseFloat(point.value))) {
                tooltipPoints.push(seriesModel.getWrappedPoint(categoryIndex));
            }
        });
    });
    if (!categoryAxis.length) {
        var xAxis = valueAxis.filter(function (axis) { return axis.type === 'xAxis'; })[0];
        var axisSeries = (xAxis === null || xAxis === void 0 ? void 0 : xAxis.getAxisSeries()) || [];
        if (axisSeries.some(function (series) { return series.type !== 'scatter'; })) {
            getClosestPoints(xAxis, x).forEach(function (point) { return tooltipPoints.push(point); });
            category = tooltipPoints[0].name;
            if (xAxis.getOption().type === 'time') {
                var date = dayjs(category);
                var hour = date.hour();
                var minute = date.minute();
                var second = date.second();
                if (second) {
                    category = date.format('YYYY-MM-DD HH:mm:ss');
                }
                else if (!second && (hour || minute)) {
                    category = date.format('YYYY-MM-DD HH:mm');
                }
                else {
                    category = date.format('YYYY-MM-DD');
                }
            }
        }
    }
    return { points: tooltipPoints, dataIndex: dataIndex, category: category };
}
